import  {useEffect, useState} from "react";
import classNames from "classnames";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import ProductDropdown from "../../components/v2/dropdown-menu/product-dropdown";
import UseCaseDropdown from "../../components/v2/dropdown-menu/use-case-dropdown";
import LearnDropdown from "../../components/v2/dropdown-menu/learn-more";
// import Hellobar from "../../components/hellobar";

export default function HeaderV2() {
    const [isProductDropdownShown, setIsProductDropdownShown] = useState(false);
    const [isSolutionDropdownShown, setSolutionDropdownShown] = useState(false);
    const [isLearnDropdownShown, setLearnDropdownShown] = useState(false);
    const [isMobNavItemsOpen, setIsMobNavItemsOpen] = useState(false);
    const [linkClicked, setLinkClicked] = useState(false);


    const onProductMouseEnter = (e) => {
        if(!isMobNavItemsOpen){
            setIsProductDropdownShown(true)
        }
    }
    const onSolutionMouseEnter = (e) => {
        if(!isMobNavItemsOpen){
            setSolutionDropdownShown(true)
        }
    }
    const onLearnMouseEnter = (e) => {
        if(!isMobNavItemsOpen){
            setLearnDropdownShown(true)
        }
    }
    const onProductMouseLeave = (e) => {
        if(!isMobNavItemsOpen){
            setIsProductDropdownShown(false)
        }
    }
    const onSolutionMouseLeave = (e) => {
        if(!isMobNavItemsOpen){
            setSolutionDropdownShown(false)
        }
    }
    const onLearnMouseLeave = (e) => {
        if(!isMobNavItemsOpen){
            setLearnDropdownShown(false)
        }
    }
    const toggleDiv = () => {
        setIsMobNavItemsOpen(!isMobNavItemsOpen)
    }
    const menuClicked = (key) => {
        if(isMobNavItemsOpen && key === 'product'){
            setIsProductDropdownShown(!isProductDropdownShown)

        }
        if(isMobNavItemsOpen && key === 'solutions'){
            setSolutionDropdownShown(!isSolutionDropdownShown)
        }
        if(isMobNavItemsOpen && key === 'learn'){
            setLearnDropdownShown(!isLearnDropdownShown)
        }
    }
    const updateStates = () => {
        if(window.innerWidth > 991 ){
            setIsMobNavItemsOpen(false)
            setIsProductDropdownShown(false)
            setSolutionDropdownShown(false)
            setLearnDropdownShown(false)
        }
    }
    const link_is_external =(link_element) =>{
        return (link_element.host !== window.location.host);
    }

    let isMobile : boolean
    useEffect(() => {

        var mobile = typeof window !== "undefined" && window.matchMedia("(max-width: 991px)")
        isMobile = mobile.matches
        window.addEventListener('resize', updateStates);
        window.addEventListener('scroll', isSticky);

        return () => {
            window.removeEventListener('resize', updateStates);
            window.removeEventListener('scroll', isSticky);
        }

    }, [])

    const isSticky = (e) => {
        const header = document.querySelector('.top-nav');
        const scrollTop = window.scrollY;
        if (header) {
            scrollTop >= 10 ? header.classList.add('mw-sticky') : header.classList.remove('mw-sticky');
        }
    };

    const removeLinkClick = () => {
        setLinkClicked(false)
    }

    // const [isHelloBarClosed, setIsHelloBarClosed] = useState(false);

    const handleHelloBarClose = (isClosed : boolean) => {
        // setIsHelloBarClosed(isClosed);
    };

    const { t } = useTranslation("header");

    return (
    <header className={'header-top'}>
        {/* <Hellobar onCloseChange={handleHelloBarClose} /> */}
        <nav id={'top-nav'} className={classNames("top-nav", {

        })} >
            <div className={'container'}>
                <div className={'d-flex'}>
                    <div className={'nav-wrapper'}>
                        <div className={'logo'}>
                            <Link key={"mw-logo"} href="/" aria-label="Middleware logo" passHref>
                                <img src={"/images/middleware-logo.svg"} alt={'Middleware Logos'} width={'215'} height={'28'} />
                            </Link>
                        </div>
                        <button
                            className={`${isMobNavItemsOpen ? 'button-cross' : ''} hamburger-button`}
                            onClick={() => toggleDiv()}
                            aria-label={isMobNavItemsOpen ? 'Close menu' : 'Open menu'}
                        >
                            <span className={'icon-bar'}></span>
                            <span className={'icon-bar'}></span>
                            <span className={'icon-bar'}></span>
                        </button>

                    </div>
                    <div className={`${isMobNavItemsOpen ? 'mobile_nav-items' : ''} nav-items`}>
                        <div className={'nav-links'}>
                            <ul className={'nav-list'}>
                                <li  className={'has-dropdown'} onClick={() => menuClicked('product')} onMouseEnter={(e)=>onProductMouseEnter(e)} onMouseLeave={(e)=>onProductMouseLeave(e)}>
                                    <Link prefetch={false} href="/product/"><span className={`d-flex main-menu ${isProductDropdownShown ? "active" : ""}`}>{t('aboutCompanyName.product')}</span></Link>
                                    <div className={'padding-div'}>
                                        <div className={`${isProductDropdownShown ? 'dropdown-open' : ''}  dropdown-item is-product-dropdown ${!isProductDropdownShown && linkClicked ? "link-clicked" : ""}`}>
                                           <div className={`dropdown-child`}>
                                               <ProductDropdown onLinkClick={() => {
                                                   setIsProductDropdownShown(!isProductDropdownShown)
                                                   setIsMobNavItemsOpen(false)
                                                   setLinkClicked(true)
                                                   setTimeout(removeLinkClick, 5000);
                                                   }}
                                               />
                                           </div>
                                    </div>
                                    </div>
                                </li>
                                <li  className={'has-dropdown'} onClick={() => menuClicked('solutions')} onMouseEnter={(e)=>onSolutionMouseEnter(e)} onMouseLeave={(e)=>onSolutionMouseLeave(e)}>
                                    <span className={`d-flex main-menu ${isSolutionDropdownShown ? "active" : ""}`}>{t('productsName.solutions')}</span>
                                    <div className={'padding-div'}>
                                        <div className={`${isSolutionDropdownShown ? 'dropdown-open' : ''} dropdown-item is-solution-dropdown ${!isSolutionDropdownShown && linkClicked ? "link-clicked" : ""}`}>
                                        <div className={`dropdown-child`}>
                                            <UseCaseDropdown onLinkClick={()=>{
                                            setSolutionDropdownShown(!isSolutionDropdownShown)
                                            setIsMobNavItemsOpen(false)
                                            setLinkClicked(true)
                                            setTimeout(removeLinkClick, 5000);
                                        }} />
                                        </div>
                                    </div>
                                    </div>
                                </li>
                                <li ><Link href={'/pricing/'} aria-label={'mw-pricing'} passHref prefetch={false}>{t('productsName.pricing')}</Link></li>
                                <li ><Link prefetch={false} href={'https://docs.middleware.io'} aria-label={'mw-customers'} target={"_blank"} passHref>{t('resourcesName.docs')}</Link></li>
                                <li  className={'has-dropdown'} onClick={() => menuClicked('learn')} onMouseEnter={(e)=>onLearnMouseEnter(e)} onMouseLeave={(e)=>onLearnMouseLeave(e)}>
                                    <span className={`d-flex main-menu ${isLearnDropdownShown ? "active" : ""}`}>{t('aboutCompanyName.learn')}</span>
                                    <div className={'padding-div'}>
                                        <div className={`${isLearnDropdownShown ? 'dropdown-open' : ''} dropdown-item is-learn-dropdown`}>
                                        <div className={`dropdown-child`}>
                                            <LearnDropdown />
                                        </div>
                                    </div>
                                    </div>
                                </li>
                            </ul>
                            <Link key={"mw-login"} href={'https://app.middleware.io/auth/login/'} target="_blank" className={'sign-up ahref-btn secondary'} aria-label={'Middleware Login'} passHref>{t('logInSignUp.logIn')}</Link>
                            <Link key={"mw-register"} href={'https://app.middleware.io/auth/register/'} target="_blank" className={'sign-up ahref-btn primary'} aria-label={'Middleware Register'} passHref>{t('logInSignUp.signUp')}</Link>
                            
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    </header>
  )
}
